module.exports = __webpack_public_path__ + "static/img/yk4120.7673aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk4120.png
// module id = ql/P
// module chunks = 1